import { render, staticRenderFns } from "./BatchUploader.vue?vue&type=template&id=bbc19732&scoped=true&lang=pug&"
import script from "./BatchUploader.vue?vue&type=script&lang=js&"
export * from "./BatchUploader.vue?vue&type=script&lang=js&"
import style0 from "./BatchUploader.vue?vue&type=style&index=0&id=bbc19732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc19732",
  null
  
)

export default component.exports